import { API } from 'aws-amplify';

export async function getStreamUptime(stream: VideoStream): Promise<UptimeEvent[]> {
  try {
    const start = Date.now() - ((stream.retentionPeriodInHours || 720) * 3600000)
    const end = Date.now();
    const path: string = `/streams/${stream.siteId}/${stream.kvsName}/status-changes?startTimestamp=${start}&endTimestamp=${end}`;

    const data = await API.get(
      'api-service',
      path,
      {}
    )

    if (data.data.length === 0) {
      return [{
        src: stream.kvsName,
        status: stream.statusOnDevice === "online" ? "online" : "offline",
        timestamp: Date.now() - (
          3600000 *
          ((stream.retentionPeriodInHours || 720) * 3600000)
        )
      }]
    }

    return data.data as UptimeEvent[]
  } catch (error) {
    console.log(error);
    return [{
      src: stream.kvsName,
      status: stream.statusOnDevice === "online" ? "online" : "offline",
      timestamp: Date.now() - (
        3600000 *
        ((stream.retentionPeriodInHours || 720) * 3600000)
      )
    }]
  }
}